import { Route } from 'react-router-dom';

import AskSlack from '@/features/Setting/Integrations/integrationRedirection/ask-slack';
import DiscordRedirect from '@/features/Setting/Integrations/integrationRedirection/discord';
import DiscordFailPage from '@/features/Setting/Integrations/integrationRedirection/discord-fail';
import FrontRedirect from '@/features/Setting/Integrations/integrationRedirection/front';
import GongRedirect from '@/features/Setting/Integrations/integrationRedirection/gong';
import GorgiasRedirect from '@/features/Setting/Integrations/integrationRedirection/gorgias';
import GorgiasRedirectPage from '@/features/Setting/Integrations/integrationRedirection/gorgias-redirect';
import HelpScoutRedirect from '@/features/Setting/Integrations/integrationRedirection/helpscout';
import IntercomRedirect from '@/features/Setting/Integrations/integrationRedirection/intercom';
import MicrosoftLoginRedirect from '@/features/Setting/Integrations/integrationRedirection/microsoft';
import SlackRedirect from '@/features/Setting/Integrations/integrationRedirection/slack';
import SlackWebhookRedirect from '@/features/Setting/Integrations/integrationRedirection/slack_webhook';
import SlackFailPage from '@/features/Setting/Integrations/integrationRedirection/slack-fail';
import TiktokShopRedirect from '@/features/Setting/Integrations/integrationRedirection/tiktokshop';
import TypeformRedirect from '@/features/Setting/Integrations/integrationRedirection/typeform';
import YotpoRedirect from '@/features/Setting/Integrations/integrationRedirection/yotpo';
import ZendeskRedirect from '@/features/Setting/Integrations/integrationRedirection/zendesk';

const integrationRoutes = (
  <>
    <Route path="discord-fail" element={<DiscordFailPage />} />
    <Route path="discord" element={<DiscordRedirect />} />
    <Route path="front" element={<FrontRedirect />} />
    <Route path="intercom" element={<IntercomRedirect />} />
    <Route path="gorgias" element={<GorgiasRedirect />} />
    <Route path="typeform" element={<TypeformRedirect />} />
    <Route path="gorgias-redirect" element={<GorgiasRedirectPage />} />
    <Route path="microsoft" element={<MicrosoftLoginRedirect />} />
    <Route path="slack_webhook" element={<SlackWebhookRedirect />} />
    <Route path="slack-fail" element={<SlackFailPage />} />
    <Route path="slack" element={<SlackRedirect />} />
    <Route path="zendesk" element={<ZendeskRedirect />} />
    <Route path="gong" element={<GongRedirect />} />
    <Route path="yotpo" element={<YotpoRedirect />} />
    <Route path="tiktokshop" element={<TiktokShopRedirect />} />
    <Route path="helpscout" element={<HelpScoutRedirect />} />
    <Route path="slack-ask-bot" element={<AskSlack />} />
  </>
);

export default integrationRoutes;
